import {
  CreateContactoRequestSchema,
  CreateContactoResponseSchema,
  CreatePreReservaRequestSchema,
  CreatePreReservaResponseSchema,
  CreatePresupuestoRequestSchema,
  CreatePresupuestoResponseSchema,
  PreReservaListQuerySchema,
  PreReservaSchema,
  PresupuestoListQuerySchema,
  PresupuestoSchema,
  UpdatePresupuestoStateRequestSchema,
} from '@visep/shared-types/presupuestos';
import type {
  CreateContactoRequest,
  CreateContactoResponse,
  CreatePreReservaRequest,
  CreatePreReservaResponse,
  CreatePresupuestoRequest,
  CreatePresupuestoResponse,
  PreReserva,
  PreReservaListQuery,
  Presupuesto,
  PresupuestoEstado,
  PresupuestoListQuery,
} from '@visep/shared-types/presupuestos';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, toQuery } from './internal.js';

export function createPresupuestosResource({ request }: Helpers) {
  return {
    async create(input: CreatePresupuestoRequest): Promise<CreatePresupuestoResponse> {
      const parsed = CreatePresupuestoRequestSchema.parse(input);
      const data = await request('POST', '/api/presupuestos', parsed);
      return CreatePresupuestoResponseSchema.parse(data);
    },
    async list(query?: PresupuestoListQuery): Promise<ListResult<Presupuesto>> {
      const parsed = PresupuestoListQuerySchema.parse(query ?? {});
      return listResultSchema(PresupuestoSchema).parse(
        await request('GET', `/api/presupuestos${toQuery(parsed)}`),
      );
    },
    async updateEstado(id: string, estado: PresupuestoEstado): Promise<{ id: string; estado: string }> {
      const parsed = UpdatePresupuestoStateRequestSchema.parse({ estado });
      return (await request('PATCH', `/api/presupuestos/${encodeURIComponent(id)}/estado`, parsed)) as {
        id: string;
        estado: string;
      };
    },
  };
}

export function createContactosResource({ request }: Helpers) {
  return {
    async create(input: CreateContactoRequest): Promise<CreateContactoResponse> {
      const parsed = CreateContactoRequestSchema.parse(input);
      const data = await request('POST', '/api/contactos', parsed);
      return CreateContactoResponseSchema.parse(data);
    },
  };
}

export function createPreReservasResource({ request }: Helpers) {
  return {
    async create(input: CreatePreReservaRequest): Promise<CreatePreReservaResponse> {
      const parsed = CreatePreReservaRequestSchema.parse(input);
      const data = await request('POST', '/api/pre-reservas', parsed);
      return CreatePreReservaResponseSchema.parse(data);
    },
    async list(query?: PreReservaListQuery): Promise<ListResult<PreReserva>> {
      const parsed = PreReservaListQuerySchema.parse(query ?? {});
      return listResultSchema(PreReservaSchema).parse(
        await request('GET', `/api/pre-reservas${toQuery(parsed)}`),
      );
    },
  };
}
